import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import SpinningIcon from "../../../../components/SpinningIcon";
import { Toast } from "../../../../components/Toast";
import ConfirmationDialog from "../../../../components/dialogs/ConfirmationDialog";
import { NotificationContext } from "../../../../contexts/NotificationContext";

const ScanPostureButton = ({ loadingMessage, setLoading, ...props }) => {
  const { isLoading, setIsLoading, setIsScanning, setTaskId } =
    useContext(NotificationContext);
  const colors = useColors();
  const [anchorEl, setAnchorEl] = useState(null);
  const { requestPostureScan } = useAPI();
  const [openDialog, setOpenDialog] = useState(false);
  const [buildRelatedData, setBuildRelatedData] = useState(true);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  function scanPosture(shouldBuildRelatedData) {
    setIsLoading(true);
    requestPostureScan(shouldBuildRelatedData).then((result) => {
      setIsScanning(true);
      Toast.info("Updating data in the background...");
      setTaskId(result.data);
    });
  }

  const handleScanClick = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleConfirm = async () => {
    scanPosture(buildRelatedData);
    setAnchorEl(null);
    setOpenDialog(false);
  };

  return (
    <>
      <CustomToolTip title={isLoading ? loadingMessage : ""}>
        <Button
          sx={{
            background: colors.grey_50,
            color: colors.contrast_text_dark,
            height: "32px",
            marginLeft: "5px",
            border: "1px solid",
            borderRadius: "8px",
          }}
          startIcon={<SpinningIcon isLoading={isLoading} />}
          onClick={handleScanClick}
          disabled={isLoading}
          {...props}
        >
          {isLoading ? "Scanning..." : "Scan Posture"}
        </Button>
      </CustomToolTip>
      <ConfirmationDialog
        openDialog={openDialog}
        handleDialogClose={handleDialogClose}
        handleConfirm={handleConfirm}
        dialogContentFirstLine="Are you sure you want to scan posture?"
        dialogContentSecondLine="This action can take a few minutes."
        confirmationButtonText="Scan"
        extraContent={
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={buildRelatedData}
                onChange={(event) => setBuildRelatedData(event.target.checked)}
              />
            }
            label="Build related data (heatmaps, widgets, MITRE, etc.)"
            sx={{ color: colors.text_secondary }}
          />
        }
      />
    </>
  );
};

export default ScanPostureButton;
